export const registrationTypes = {
  open: {id: 1, name: 'Открытая'},
  closed: {id: 2, name: 'Закрытая'},
  personalAccounts: {id: 3, name: 'По лицевому счету'},
}